import React from 'react';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';






export default function LoadingSpinnerComponent({
  isLoading,
  msg
}) {
  return (

    <LoadingSpinner
      size="$md"
      isLoading={isLoading}
      ariaLoadingLabel={msg}
    />

  );
}
